import { useEffect, useMemo, useState } from "react";
import { getPresetSync } from "./myPresetSync";

export default function useMyPresetSync(uid) {
  const service = useMemo(() => getPresetSync(uid), [uid]);
  const [snapshot, setSnapshot] = useState(() => service.getSnapshot());
  useEffect(() => {
    const unsubscribe = service.subscribe(setSnapshot);
    setSnapshot(service.getSnapshot());
    service.start(); // Refetch on open only when stale or changes are pending.
    return unsubscribe;
  }, [service]);
  return { ...snapshot, save: service.save, reorder: service.reorder, retry: service.sync };
}
